<template>
    <div class="my-8">
      <div class="tickets-dashboard-graph-container">
          <div ref="taskStepsGraph" style="width: 100%; height: 100%; overflow: hidden;"></div>
      </div>
    </div>
  </template>
  
  <script>
  const echarts = require('echarts');
  import { EventBus } from '../../../../../../eventBus';
  export default {
      name: "StepsInsightDashboardGraph",
      props: {
        graphValues: {
            type: Array,
            required: true,
        },
        graphColors: {
            type: Array,
            required: true,
        },
        graphLabels: {
            type: Array,
            required: true,
        },
      },
      data() {
          return {
              ticketLocationGraphInstance: '',
              option: {
                  color: [],
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'shadow'
                      }
                  },
                  dataZoom: [
                    {
                        show: false,
                        startValue: 0,
                        endValue: 100,
                        zoomLock: true,
                        moveOnMouseWheel: true,
                    },
                    {
                        show: false,
                        height: 20,
                        zoomLock: true,
                        zoomOnMouseWheel: false,
                        moveOnMouseMove: false,
                        moveOnMouseWheel: true,
                        preventDefaultMouseMove: true,
                        bottom: '0'
                    },
                    {
                        show: true,
                        type: 'slider',
                        yAxisIndex: 0,
                        startValue: 100,
                        endValue: 92,
                        filterMode: 'empty',
                        width: 20,
                        height: '93%',
                        top: '0',
                        labelFormatter: '',
                        showDataShadow: false,
                        zoomLock: true,
                        zoomOnMouseWheel: false,
                        moveOnMouseMove: false,
                        moveOnMouseWheel: true,
                        preventDefaultMouseMove: true,
                        left: '93%'
                    }
                ],
                  grid: {
                    left: '10%',
                    right: '15%',
                    top: '0',
                    bottom: '10%',
                  },
                  legend: {
                    show: false
                  },
                  yAxis: [
                      {
                          type: 'category',
                          axisTick: {
                            alignWithLabel: true
                          },
                          // prettier-ignore
                          data: [],
                          axisLabel: {
                            interval: 0,
                            rotate: 45, //If the label names are too long you can manage this by rotating the label.
                            overflow: 'truncate',
                            ellipsis: '...',
                            formatter: val => this.excerptText(val)
                        },
                      }
                  ],
                  xAxis: [
                      {
                          type: 'value',
                          name: '',
                          min: 0,
                          interval:25,
                          max: 100,
                          position: 'left',
                          alignTicks: true,
                          axisLine: {
                              show: true,
                              lineStyle: {
                                  color: '#333333'
                              }
                          },
                          axisLabel: {
                            formatter: '{value} %'
                          }
                      }
                  ],
                  series: [
                      {
                          name: 'Steps %',
                          type: 'bar',
                          yAxisIndex: 0,
                          barWidth: 20,
                          data: [],
                          label: {
                            show: true,
                            position: 'right',
                            color: '#FFFFFF',
                            backgroundColor: '#d26300',
                            padding: 4,
                            fontSize: 12,
                            formatter: '{c}%'
                        }
                      }
                  ]
              }
          }
      },
      watch: {
        graphValues(newValue, oldValue) {
            this.reRenderGraph();
        }
      },
      methods:{
          initGraph() {
              let chartContainer = this.$refs.taskStepsGraph;
              this.ticketLocationGraphInstance = echarts.init(chartContainer);
            //   this.ticketLocationGraphInstance.showLoading();
          },
          reRenderGraph() {
            this.initGraph();
            // this.ticketLocationGraphInstance.showLoading();
            this.option.color = [...this.graphColors];
            this.option.series[0].data = this.graphValues.map((el, index) => ({
                value: el,
                itemStyle: {
                    color: this.graphColors[index]
                }
            }));
            this.option.yAxis[0].data = this.graphLabels.map(el => el);
            this.ticketLocationGraphInstance.setOption(this.option);
            // this.ticketLocationGraphInstance.hideLoading();
          },
          excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		    },
      }
  
  }
  </script>
  
  <style>
  .tickets-dashboard-graph-container{
      background-color:#ffffff;
      /* padding:25px; */
      height:300px;
      width:100%;
      margin: 20px 0;
  
  }
  </style>